
import Api from '@/utils/api';
import Scroller from 'vux/src/components/scroller/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Popup from 'vux/src/components/popup/index.vue'


export default {
components: {
Scroller,
XImg,
Popup
},
methods: {
toCreateOrder() {
this.$router.push({
name: 'createOrder',
query: {
coupon: JSON.stringify(this.selectedProducts)
}
})
},
addProduct(product) {
const findProduct = _.find(this.selectedProducts, {_id: product._id})
if (findProduct) {
findProduct.quantity += 1
} else {
product.quantity = 1
this.selectedProducts.push(product)
}
this.selectedProductsLength += 1
this.getTotalPrice()
this.$vux.toast.text('加入成功')
console.log(this.selectedProducts)
},
getProductsPrice () {
let productsPrice = 0
_.forEach(this.selectedProducts, (product) => {
productsPrice += product.price * product.quantity
})
this.productsPrice = productsPrice
},
getDiscount () {
let discount = 0
_.forEach(this.selectedProducts, (product) => {
if(product.isUseCoupon){
discount += product.price
}
})
this.discount = discount
},
getTotalPrice () {
this.getProductsPrice()
this.getDiscount()
this.totalPrice =  this.productsPrice  - this.discount
}
},
data() {
return {
showPopup: false,
couponProduct: {},
products: [],
selectedProducts: [],
totalPrice: 0,
selectedProductsLength: 1
}
},
mounted() {
if(this.$route.query.coupon){
const data = JSON.parse(this.$route.query.coupon)
data.product.isUseCoupon = true
data.product.quantity = 1
data.product.couponId = data._id
data.product.couponFixedFreight = data.fixedFreight
data.product.couponFreight = data.freight
this.couponProduct = data.product
this.selectedProducts.push(this.couponProduct)
this.getTotalPrice()
}

Api.getProductList({limit: 0})
.then(res => {
this.products = res.data
_.remove(this.products, (product) => {
return product._id === this.couponProduct._id
})
})
},
computed: {
},
created () {

}

};



// WEBPACK FOOTER //
// ./src/components/Recommend/Recommend.vue